<div *ngIf="preTitlePresent">
    <span *ngIf="preTitle1Present" class="text-uppercase">
        <a  [href]="pre_title1_url" [target]="pre_title1_target" [ngClass]="ctaTheme" tabindex="0">
            <img *ngIf="hasPreTitle1UrlIcon && pre_title1_iconAlign=='left'" [src]="pre_title1_iconUrl" [alt]="pre_title1_iconText" loading="lazy" class="iconStyle">
            <span *ngIf="pre_title1_iconUrl && !hasPreTitle1UrlIcon && pre_title1_iconAlign=='left'" [ngClass]="pre_title1_iconUrl" aria-hidden="true"></span>
            {{pre_title1_text}}
            <img *ngIf="hasPreTitle1UrlIcon && pre_title1_iconAlign=='right'" [src]="pre_title1_iconUrl" [alt]="pre_title1_iconText" loading="lazy" class="iconStyle">
            <span *ngIf="pre_title1_iconUrl && !hasPreTitle1UrlIcon && pre_title1_iconAlign=='right'" [ngClass]="pre_title1_iconUrl" aria-hidden="true"></span>
            <span *ngIf="pre_title1_urlAlt" class="sr-only">{{pre_title1_urlAlt}}</span>
        </a>
    </span>
    <span *ngIf="!preTitle1Present" class="titleDisplay">
        PRETITLE1
    </span>
</div>
<h2 *ngIf="longShortTitle" class="title" >
    <div *ngIf="shortTitlePresent">
        <small *ngIf="short_title_1" class="headings-small-eyebrow" [ngClass]="shortTitleTheme" >{{short_title_1}}</small>
        <small *ngIf="!short_title_1" class="headings-small-eyebrow titleDisplay">Short</small>
    </div>
    <div *ngIf="longTitlePresent">
        <div *ngIf="long_title_1" [ngClass]="longTitleTheme" >{{long_title_1}}</div>
        <div *ngIf="!long_title_1" class="titleDisplay">Long</div>
    </div>
</h2>
<figure *ngIf="image_url">
    <img  [src] = "image_url" class = "img-responsive" [alt] = "image_altText" loading="lazy">
    <figcaption *ngIf="image_caption" [ngClass]="paraTheme">{{image_caption}} </figcaption>
    <div *ngIf="hasContentAfterImage || bulletPoints.length >0" class="paddingAfterImage"></div>
</figure>
<span *ngIf="preTitle2Present" class="text-uppercase">
    <a [href]="pre_title2_url" [target]="pre_title2_target" [ngClass]="ctaTheme">
        <img *ngIf="hasPreTitle2UrlIcon && pre_title2_iconAlign=='left'" [src]="pre_title2_iconUrl" [alt]="pre_title2_iconText" loading="lazy" class="iconStyle">
        <span *ngIf="pre_title2_iconUrl && !hasPreTitle2UrlIcon && pre_title2_iconAlign=='left'" [ngClass]="pre_title2_iconUrl" aria-hidden="true"></span>
        {{pre_title2_text}}
        <img *ngIf="hasPreTitle2UrlIcon && pre_title2_iconAlign=='right'" [src]="pre_title2_iconUrl" [alt]="pre_title2_iconText" loading="lazy" class="iconStyle">
        <span *ngIf="pre_title2_iconUrl && !hasPreTitle2UrlIcon && pre_title2_iconAlign=='right'" [ngClass]="pre_title2_iconUrl" aria-hidden="true"></span>
        <span *ngIf="pre_title2_urlAlt" class="sr-only">{{pre_title2_urlAlt}}</span>
    </a>
</span>
<h2 *ngIf="short_title_2 || long_title_2">
    <small *ngIf="short_title_2" class="headings-small-eyebrow" [ngClass]="shortTitleTheme">{{short_title_2}}</small>
    <div *ngIf="long_title_2" [ngClass]="longTitleTheme">{{long_title_2}}</div>
</h2>
<p *ngIf="date && !readTime && !author" [ngClass]="paraTheme">
    <span>{{date}}</span>
</p>
<p *ngIf="!date && readTime && !author" [ngClass]="paraTheme">
    <span>{{readTime}} Read</span>
</p>
<p *ngIf="!date && !readTime && author" [ngClass]="paraTheme">
    <span>{{author}}</span>
</p>
<p *ngIf="date && readTime && !author" [ngClass]="paraTheme">
    <span>{{date}}</span> | <span>{{readTime}} Read</span>
</p>
<p *ngIf="date && !readTime && author" [ngClass]="paraTheme">
    <span>{{date}}</span> | <span>{{author}}</span>
</p>
<p *ngIf="!date && readTime && author" [ngClass]="paraTheme">
    <span>{{readTime}} Read</span> | <span>{{author}}</span>
</p>
<p *ngIf="date && readTime && author" [ngClass]="paraTheme">
    <span>{{date}}</span> | <span>{{readTime}} Read</span> | <span>{{author}}</span>
</p>
<div *ngIf="postTitlePresent">
    <a *ngIf="post_title_url" [href]="post_title_url" [target]="post_title_target">
        <h3>
            <small class="headings-small-eyebrow" [ngClass]="longTitleTheme">
                <img *ngIf="hasPostTitleUrlIcon && post_title_iconAlign=='left'" [src]="post_title_iconUrl" [alt]="post_title_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="post_title_iconUrl && !hasPostTitleUrlIcon && post_title_iconAlign=='left'" [ngClass]="post_title_iconUrl" aria-hidden="true"></span>
                    <u> {{post_title_text}} </u>
                <img *ngIf="hasPostTitleUrlIcon && post_title_iconAlign=='right'" [src]="post_title_iconUrl" [alt]="post_title_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="post_title_iconUrl && !hasPostTitleUrlIcon && post_title_iconAlign=='right'" [ngClass]="post_title_iconUrl" aria-hidden="true"></span>
            </small>
        </h3> 
        <span *ngIf="post_title_urlAlt" class="sr-only">{{post_title_urlAlt}}</span>
    </a>    
</div>
<p dir="ltr" *ngIf="text_1"  [ngClass]="paraTheme" >{{text_1}}  </p>
<p dir="ltr" *ngIf="text_1_para"  [ngClass]="paraTheme" >{{text_1_para}}  </p>
<p dir="ltr" *ngIf="text_2" [ngClass]="paraTheme" ><em>{{text_2}}</em></p>

<ul *ngIf="bulletPoints.length > 0">
        <li *ngFor="let bulletPoint of bulletPoints" [ngClass]="longTitleTheme" >
            <span [ngClass]="ctaTheme">{{bulletPoint}}</span>
        </li>
</ul>
<div *ngIf="subHeadingPresent">
    <a *ngIf="sub_heading_url" [href]="sub_heading_url" [target]="sub_heading_target">
        <h3>
            <small class="headings-small-eyebrow" [ngClass]="shortTitleTheme">
                <img *ngIf="hasSubHeadingUrlIcon && sub_heading_iconAlign=='left'" [src]="sub_heading_iconUrl" [alt]="sub_heading_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="sub_heading_iconUrl && !hasSubHeadingUrlIcon && sub_heading_iconAlign=='left'" [ngClass]="sub_heading_iconUrl" aria-hidden="true"></span>
                {{sub_heading_text}}
                <img *ngIf="hasSubHeadingUrlIcon && sub_heading_iconAlign=='right'" [src]="sub_heading_iconUrl" [alt]="sub_heading_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="sub_heading_iconUrl && !hasSubHeadingUrlIcon && sub_heading_iconAlign=='right'" [ngClass]="sub_heading_iconUrl" aria-hidden="true"></span>
            </small>
        </h3>
        <span *ngIf="sub_heading_urlAlt" class="sr-only">{{sub_heading_urlAlt}}</span>
    </a>    
</div>
<p dir="ltr" *ngIf="sub_text" [ngClass]="paraTheme" >{{sub_text}}  </p>
<div *ngIf="primaryButtonPresent">
   <a *ngIf="primary_button_url" [ngClass]="btnTypePrimary" class="btn primary_btn" [href]="primary_button_url" [target]="primary_button_target" (click)="callClickStream('primary_banner_button')">
    <input type="hidden"  [value]="contentId">
    <img *ngIf="hasPrimaryButtonUrlIcon && primary_button_iconAlign=='left'" [src]="primary_button_iconUrl" [alt]="primary_button_iconText" loading="lazy" class="iconStyle">
    <span *ngIf="primary_button_iconUrl && !hasPrimaryButtonUrlIcon && primary_button_iconAlign=='left'" [ngClass]="primary_button_iconUrl" aria-hidden="true"></span>
        {{primary_button_text}}
    <img *ngIf="hasPrimaryButtonUrlIcon && primary_button_iconAlign=='right'" [src]="primary_button_iconUrl" [alt]="primary_button_iconText" loading="lazy" class="iconStyle">
    <span *ngIf="primary_button_iconUrl && !hasPrimaryButtonUrlIcon && primary_button_iconAlign=='right'" [ngClass]="primary_button_iconUrl" aria-hidden="true"></span>
  </a>
    <div *ngIf="secondaryButtonPresent || primaryCTAPresent || secondaryCTAPresent" class="pru-module-margin"></div>
</div>
<div *ngIf="secondaryButtonPresent">
    <a *ngIf="secondary_button_url"  [ngClass]="btnTypeSecondary" class="btn secondary_btn" [href]="secondary_button_url" [target]="secondary_button_target" (click)="callClickStream('secondary_banner_button')">
        <input type="hidden"  [value]="contentId">
        <img *ngIf="hasSecondaryButtonUrlIcon && secondary_button_iconAlign=='left'" [src]="secondary_button_iconUrl" [alt]="secondary_button_iconText" loading="lazy" class="iconStyle">
        <span *ngIf="secondary_button_iconUrl && !hasSecondaryButtonUrlIcon && secondary_button_iconAlign=='left'" [ngClass]="secondary_button_iconUrl" aria-hidden="true"></span>
         {{secondary_button_text}}
         <img *ngIf="hasSecondaryButtonUrlIcon && secondary_button_iconAlign=='right'" [src]="secondary_button_iconUrl" [alt]="secondary_button_iconText" loading="lazy" class="iconStyle">
         <span *ngIf="secondary_button_iconUrl && !hasSecondaryButtonUrlIcon && secondary_button_iconAlign=='right'" [ngClass]="secondary_button_iconUrl" aria-hidden="true"></span> 
     </a>
     <div *ngIf="primaryCTAPresent || secondaryCTAPresent" class="pru-module-margin"></div>
 </div>
<div *ngIf="post_text_html" [ngClass]="longTitleTheme" class="posttexthtml" [innerHTML]="post_text_html" >
</div>
<div *ngIf="primaryCTAPresent && secondaryCTAPresent" class="row">
    <div class="col-xs-12 col-md-6">
        
            <a *ngIf="primary_CTA_url"  [ngClass]="ctaTheme"  [href]="primary_CTA_url" [target]="primary_CTA_target" >
                <img *ngIf="hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='left'" [src]="primary_CTA_iconUrl" [alt]="primary_CTA_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="primary_CTA_iconUrl && !hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='left'" [ngClass]="primary_CTA_iconUrl" aria-hidden="true">&nbsp;{{primary_CTA_text}}</span>
                <span *ngIf="primary_CTA_iconUrl && hasPrimaryCTAUrlIcon" >{{primary_CTA_text}}</span>
                <img *ngIf="hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='right'" [src]="primary_CTA_iconUrl" [alt]="primary_CTA_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="primary_CTA_iconUrl && !hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='right'">{{primary_CTA_text}}&nbsp;</span>
                <span *ngIf="primary_CTA_iconUrl && !hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='right'" [ngClass]="primary_CTA_iconUrl" aria-hidden="true"></span>
                <span *ngIf="!primary_CTA_iconUrl">{{primary_CTA_text}}</span>
                <span *ngIf="primary_CTA_urlAlt" class="sr-only">{{primary_CTA_urlAlt}}</span>
            </a>
        
    </div>
    <div class="col-xs-12 col-md-6">
        
            <a *ngIf="secondary_CTA_url"  [ngClass]="ctaTheme"  [href]="secondary_CTA_url" [target]="secondary_CTA_target">
                <img *ngIf="hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='left'" [src]="secondary_CTA_iconUrl" [alt]="secondary_CTA_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="secondary_CTA_iconUrl && !hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='left'" [ngClass]="secondary_CTA_iconUrl" aria-hidden="true">&nbsp;{{secondary_CTA_text}}</span>
                <span *ngIf="secondary_CTA_iconUrl && hasSecondaryCTAUrlIcon" >{{secondary_CTA_text}}</span>
                <img *ngIf="hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='right'" [src]="secondary_CTA_iconUrl" [alt]="secondary_CTA_iconText" loading="lazy" class="iconStyle">
                <span *ngIf="secondary_CTA_iconUrl && !hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='right'">{{secondary_CTA_text}}&nbsp;</span>
                <span *ngIf="secondary_CTA_iconUrl && !hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='right'" [ngClass]="secondary_CTA_iconUrl" aria-hidden="true"></span>
                <span *ngIf="!secondary_CTA_iconUrl">{{secondary_CTA_text}}</span>
                <span *ngIf="secondary_CTA_urlAlt" class="sr-only">{{secondary_CTA_urlAlt}}</span>
            </a>
        
    </div>
</div>
<div *ngIf="primaryCTAPresent && !secondaryCTAPresent">
    <a *ngIf="primary_CTA_url"  [ngClass]="ctaTheme"  [href]="primary_CTA_url" [target]="primary_CTA_target">
        <img *ngIf="hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='left'" [src]="primary_CTA_iconUrl" [alt]="primary_CTA_iconText" loading="lazy" class="iconStyle">
        <span *ngIf="primary_CTA_iconUrl && !hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='left'" [ngClass]="primary_CTA_iconUrl" aria-hidden="true">&nbsp;{{primary_CTA_text}}</span>
        <span *ngIf="primary_CTA_iconUrl && hasPrimaryCTAUrlIcon">{{primary_CTA_text}}</span>
        <img *ngIf="hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='right'" [src]="primary_CTA_iconUrl" [alt]="primary_CTA_iconText" loading="lazy" class="iconStyle">
        <span *ngIf="primary_CTA_iconUrl && !hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='right'">{{primary_CTA_text}}&nbsp;</span>
        <span *ngIf="primary_CTA_iconUrl && !hasPrimaryCTAUrlIcon && primary_CTA_iconAlign=='right'" [ngClass]="primary_CTA_iconUrl" aria-hidden="true"></span>
        <span *ngIf="!primary_CTA_iconUrl">{{primary_CTA_text}}</span>
        <span *ngIf="primary_CTA_urlAlt" class="sr-only">{{primary_CTA_urlAlt}}</span>
    </a>
</div>
<div *ngIf="!primaryCTAPresent && secondaryCTAPresent">
    <a *ngIf="secondary_CTA_url"  [ngClass]="ctaTheme"  [href]="secondary_CTA_url" [target]="secondary_CTA_target">
        <img *ngIf="hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='left'" [src]="secondary_CTA_iconUrl" [alt]="secondary_CTA_iconText" loading="lazy" class="iconStyle">
        <span *ngIf="secondary_CTA_iconUrl && !hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='left'" [ngClass]="secondary_CTA_iconUrl" aria-hidden="true">&nbsp;{{secondary_CTA_text}}</span>
        <span *ngIf="secondary_CTA_iconUrl && hasSecondaryCTAUrlIcon">{{secondary_CTA_text}}</span>
        <img *ngIf="hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='right'" [src]="secondary_CTA_iconUrl" [alt]="secondary_CTA_iconText" loading="lazy" class="iconStyle">
        <span *ngIf="secondary_CTA_iconUrl && !hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='right'">{{secondary_CTA_text}}&nbsp;</span>
        <span *ngIf="secondary_CTA_iconUrl && !hasSecondaryCTAUrlIcon && secondary_CTA_iconAlign=='right'" [ngClass]="secondary_CTA_iconUrl" aria-hidden="true"></span>
        <span *ngIf="!secondary_CTA_iconUrl" >{{secondary_CTA_text}}</span>
        <span *ngIf="secondary_CTA_urlAlt" class="sr-only">{{secondary_CTA_urlAlt}}</span>
    </a>
</div>
<div *ngIf="bufferContentPresent" class="bufferContentStyle">
    <h4 *ngIf="buffer_heading" [ngClass]="longTitleTheme"  >{{buffer_heading}}</h4>
    <p dir="ltr" *ngIf="buffer_text" [ngClass]="paraTheme" >{{buffer_text}}</p>
    <div *ngIf="bufferContentButtonPresent">
        <a *ngIf="buffer_button_url"  [ngClass]="btnTypePrimary" class="btn buffer_btn" [href]="buffer_button_url" [target]="buffer_button_target" (click)="callClickStream('buffer_banner_button')">
            <input type="hidden"  [value]="contentId">
            <img *ngIf="hasBufferButtonUrlIcon && buffer_button_iconAlign=='left'" [src]="buffer_button_iconUrl" [alt]="buffer_button_iconText" loading="lazy" class="iconStyle">
            <span *ngIf="buffer_button_iconUrl && !hasBufferButtonUrlIcon && buffer_button_iconAlign=='left'" [ngClass]="buffer_button_iconUrl" aria-hidden="true"></span>
             {{buffer_button_text}}
             <img *ngIf="hasBufferButtonUrlIcon && buffer_button_iconAlign=='right'" [src]="buffer_button_iconUrl" [alt]="buffer_button_iconText" loading="lazy" class="iconStyle">
            <span *ngIf="buffer_button_iconUrl && !hasBufferButtonUrlIcon && buffer_button_iconAlign=='right'" [ngClass]="buffer_button_iconUrl" aria-hidden="true"></span>
        </a>
         <div *ngIf="bufferContentLinkPresent" class="pru-module-margin"></div>
     </div>
     <div *ngIf="bufferContentLinkPresent">
        <a *ngIf="buffer_link_url"  [ngClass]="ctaTheme"  [href]="buffer_link_url" [target]="buffer_link_target">
            <img *ngIf="hasBufferLinkUrlIcon && buffer_link_iconAlign=='left'" [src]="buffer_link_iconUrl" [alt]="buffer_link_iconText" loading="lazy" class="iconStyle">
            <span *ngIf="buffer_link_iconUrl && !hasBufferLinkUrlIcon && buffer_link_iconAlign=='left'" [ngClass]="buffer_link_iconUrl" aria-hidden="true"></span>
             {{buffer_link_text}}
             <img *ngIf="hasBufferLinkUrlIcon && buffer_link_iconAlign=='right'" [src]="buffer_link_iconUrl" [alt]="buffer_link_iconText" loading="lazy" class="iconStyle">
            <span *ngIf="buffer_link_iconUrl && !hasBufferLinkUrlIcon && buffer_link_iconAlign=='right'" [ngClass]="buffer_link_iconUrl" aria-hidden="true"></span>
             <span *ngIf="buffer_link_urlAlt" class="sr-only">{{buffer_link_urlAlt}}</span>
         </a>
     </div>
</div>
 

